import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { neverError } from '@iac-helpers';
import { IacSpinnerSize } from '@iac-types';

@Component({
  selector: 'iac-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class SpinnerComponent {
  public readonly size = input<IacSpinnerSize>(24);

  public readonly getSizeClass = computed(() => {
    const size = this.size();
    switch (size) {
      case 16:
        return ['text-[16px]'];
      case 24:
        return ['text-[24px]'];
      case 32:
        return ['text-[32px]'];
      case 64:
        return ['text-[64px]'];
      default:
        throw neverError(size);
    }
  });
}
